import _ from "lodash";
import {
	handleSingleCharacteristic
} from "@/helper/job-profile/ItemHelper";
import {filterLastLevel} from "@/helper/characteristic/Characteristic";

export const SOURCE_QUESTIONNAIRE = 'source-questionnaire';

const CONFIG = {
	placeOfWork: {
		custom: (data) =>
		{
			if (data.postalCodes)
			{
				data.postalCodes = _.map(data.postalCodes, 'id');
			}

			return data;
		}
	},
	placeOfWorkType: {
		extractProperty: 'id',
	},
	companyType: {
		characteristicList: true,
	},
	companySize: {
		characteristicList: true,
	},
	employmentMode: {
		characteristicList: true,
	},
	management: {
		characteristicList: true,
	},
	customerContact: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	workingTime: {
		characteristicList: true,
	},
	relocationPremise: {
		characteristicList: true,
	},
	functions: {
		characteristicList: true,
	},
	functionAssistance: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionMarketingRole: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionMarketingRoleExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true,
	},
	functionLegalField: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionLegalFieldExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	functionLegalRole: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionLegalRoleExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	functionTaxField: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionTaxFieldExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	functionTaxRole: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionTaxRoleExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	careerLevels: {
		characteristicList: true,
	},
	industrialSectors: {
		characteristicList: true,
	},
	organisationalArea: {
		characteristicList: true,
	},
	searchStatus: {
		characteristicList: true,
	},
	citizenship: {
		map: 'id',
	},
	drivingLicense: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	pilotLicense: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	benefits: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	overtime: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	parking: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	publicTransport: {
		questionnaireSkippable: true,
		characteristicList: true,
	},
	companyCar: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	privateVehicleCompanyUsage: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	externalSleepover: {
		characteristicList: true,
		questionnaireSkippable: true,
	},
	languages: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	functionsExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	careerLevelsExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	industrialSectorsExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	organisationalAreaExperience: {
		characteristicList: true,
		questionnaireSkippableInItemData: true
	},
	travelWillingness: {
		custom: (data) =>
		{
			if (data.geo)
			{
				data.geo = handleCharacteristicList(
					filterLastLevel(data.geo)
				);
			}

			if (data.scope)
			{
				data.scope = handleCharacteristicList(
					filterLastLevel(data.scope)
				);
			}

			if (data.externalSleepover)
			{
				data.externalSleepover = handleCharacteristicList(
					filterLastLevel(data.externalSleepover)
				);
			}

			return data;
		}
	},
	skills: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	softwareMain: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	softwareSpecial: {
		characteristicList: true,
		questionnaireSkippable: true
	},
	education: {
		custom: (data) =>
		{
			if (data.schoolType)
			{
				data.schoolType = data.schoolType.id;
			}

			if (data.professions)
			{
				data.professions = handleCharacteristicList(
					filterLastLevel(data.professions)
				);
			}

			return data;
		}
	}
};

export function prepare (originalData, source)
{
	const data = _.cloneDeep(originalData);

	_.forEach(data, (itemData, property) =>
	{
		if (!itemData)
		{
			return true; // continue
		}

		const config = CONFIG[property];

		if (!config)
		{
			return true; // continue
		}

		if (config.extractProperty)
		{
			data[property] = itemData ? itemData[config.extractProperty] : itemData;
		}

		if (config.map)
		{
			data[property] = _.map(itemData, config.map);
		}

		if (config.characteristicList)
		{
			if (
				source === SOURCE_QUESTIONNAIRE
				&& (config.questionnaireSkippable || config.questionnaireSkippableInItemData)
			)
			{
				data[property] = {
					items: handleCharacteristicList(
						filterLastLevel(
							config.questionnaireSkippableInItemData
								? itemData.items
								: itemData
						)
					),
					skipped: itemData.skipped
				};
			}
			else
			{
				data[property] = handleCharacteristicList(
					filterLastLevel(itemData)
				);
			}
		}

		if (config.custom)
		{
			data[property] = config.custom(itemData);
		}
	});

	return data;
}

export function handleCharacteristicList (data)
{
	return _.map(data, item => handleSingleCharacteristic(item));
}
